import styled from "styled-components";
import {goldEdgeFor, radii} from "theme/tokens";

/**
 * The ladder strip that sits between the pricing header and the plan table.
 *
 * One component paints both states, tinted by `$tone`, because they occupy the same place and differ
 * only in what they say: a live rung's offer and the notice an expired link gets. Two components would
 * be two copies of the same box.
 */
export const Strip = styled.section<{$tone: "offer" | "expired"}>`
	max-width: 680px;
	margin: 18px auto 4px;
	padding: 14px 18px;
	box-sizing: border-box;
	text-align: center;
	border-radius: ${radii.card};
	/* The live offer borrows the gold the paid surfaces use; the expired notice stays on the neutral
	   card, because nothing is being offered and a tinted box would read as one. */
	background: ${({theme, $tone}) => ($tone === "offer" ? theme.tokens.goldTint : theme.tokens.card)};
	border: 1px solid ${({theme, $tone}) => ($tone === "offer" ? goldEdgeFor(theme.tokens) : theme.tokens.cardBorder)};

	@media (max-width: 480px) {
		margin: 14px auto 2px;
		padding: 12px 14px;
	}
`;

export const Headline = styled.p`
	margin: 0;
	font-size: 15px;
	font-weight: 700;
	line-height: 1.3;
	color: ${({theme}) => theme.tokens.ink};
`;

export const Body = styled.p`
	margin: 4px 0 0;
	font-size: 13.5px;
	line-height: 1.45;
	color: ${({theme}) => theme.tokens.ink2};
`;
